import { ref, get, update } from "firebase/database";
import { db } from "./firebase";

export const getNextStudentId = async () => {
  try {
    const counterRef = ref(db, 'studentIdCounter');
    const snapshot = await get(counterRef);

    let nextId = 1;
    if (snapshot.exists()) {
      nextId = snapshot.val() + 1;
    }

    await update(ref(db), {
      'studentIdCounter': nextId
    });

    return nextId.toString().padStart(4, '0');
  } catch (error) {
    console.error("Error generating student ID:", error);
    return Date.now().toString().slice(-4);
  }
};